import { useEffect, useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { api } from "../../lib/api";
import { useLang } from "../../i18n/LangContext";
import { VCOLOR } from "./Primitives";

const ROWS = [
  ["agro", 18, "M0,11 L20,11 L28,3 L36,19 L44,11 L60,11 L68,6 L76,16 L84,11 L200,11"],
  ["mines", 11, "M0,11 L30,11 L38,2 L46,20 L54,11 L90,11 L98,5 L106,17 L114,11 L200,11"],
  ["petrole", 7, "M0,11 L14,11 L22,4 L30,18 L38,11 L120,11 L128,7 L136,15 L144,11 L200,11"],
  ["numerique", 9, "M0,11 L24,11 L32,5 L40,17 L48,11 L100,11 L108,3 L116,19 L124,11 L200,11"],
];

const Console = () => {
  const { t } = useLang();
  const items = [...t.hero.ticker, ...t.hero.ticker];
  return (
    <div className="panel console rivets-bottom" data-testid="supervision-console">
      <span className="rv" aria-hidden="true" />
      <div className="console-head">
        <span className="console-title">{t.hero.consoleTitle}</span>
        <span className="live-tag"><span className="live-dot" />{t.hero.live}</span>
      </div>
      {ROWS.map(([k, n, d], i) => (
        <div className="console-row" key={k} style={{ "--c": VCOLOR[k] }} data-testid={`console-row-${k}`}>
          <span className="status-dot" style={{ animationDelay: `${i * 0.4}s` }} />
          <span className="rlabel">{t.verticalsShort[k]}</span>
          <svg className="waveform" viewBox="0 0 200 22" preserveAspectRatio="none" aria-hidden="true">
            <path d={d} /><path className="pulse" d={d} style={{ animationDelay: `${i * 0.6}s` }} />
          </svg>
          <span className="rtime">{n} {t.hero.tickets}</span>
        </div>
      ))}
      <div className="ticker-wrap" aria-hidden="true">
        <div className="ticker-track" data-testid="hero-ticker">
          {items.map(([a, b, c], i) => (
            <span key={i}><Check size={12} className="ok" style={{ display: "inline", verticalAlign: "-2px" }} />{a}<b>{b}</b>{c}</span>
          ))}
        </div>
      </div>
    </div>
  );
};

export const Hero = () => {
  const { t } = useLang();
  const [experts, setExperts] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setExperts(r.data.experts)).catch(() => setExperts(null)); }, []);
  return (
    <section className="hero" id="top" data-testid="hero-section">
      <div className="wrap hero-grid">
        <div className="hero-in">
          <p className="eyebrow">{t.hero.eyebrow}</p>
          <h1 data-testid="hero-title">{t.hero.titleA}<span>{t.hero.titleHi}</span>{t.hero.titleB}</h1>
          <p className="lead">{t.hero.lead}</p>
          <div className="hero-actions">
            <a href="#contact" className="btn btn-primary" data-testid="hero-cta-diagnostic">{t.hero.cta1}</a>
            <a href="#services" className="btn btn-ghost" data-testid="hero-cta-services">{t.hero.cta2} <ArrowRight className="arrow" /></a>
          </div>
          <div className="hero-meta">
            {t.hero.meta.map(([v, l]) => <div key={l}><b>{v}</b><span>{l}</span></div>)}
          </div>
        </div>
        <Console />
      </div>
      <div className="wrap">
        <div className="stats-strip" data-testid="hero-stats-strip">
          {t.hero.stats.map(([v, l], i) => <div className="stat" key={l}><b data-testid={`hero-stat-${i}`}>{v === "live" ? experts ?? "—" : v}</b><span>{l}</span></div>)}
        </div>
      </div>
    </section>
  );
};
